import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { popUpMessageChange, 
        editCards, 
        deleteCards, 
        editFeaturesGroup, 
        editFigures,
        toggleSwitch,
        selectedCardsGroupsChange } from '../../actions';

import { _ } from '../../functions/translator.js';

import { Button } from '@material-ui/core';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

import SendIcon from '@material-ui/icons/Send';

import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { showMessage } from '../../functions/popUpMessage.js';
import { ToggleActions } from '../../constants/constants.js';

class ProtocolSelectCard extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            protocolIds: [],
            inputValue: ''
        }
    }

    handleOnClick = async () => {
        const message = _("Generando Nuevos Protocolos") + '...';
        showMessage(this.props, message, { loading: true });
        let urlPost = {
            project_id: this.props.projectData.id,
            protocol_ids: this.state.protocolIds,
            cards_group_ids: this.props.selectedCardsGroups,
        }
        this.handleClose()
        let response = await postData('/web-api/create-related-cards-groups', urlPost)
        this.handleResponse(response)
    }

    handleClose = () => {
        this.props.toggleSwitch(ToggleActions.SELECT_PROTOCOL, false);
        this.setState({ protocolIds: [] });
        this.setState({ inputValue: '' });
        this.props.selectedCardsGroupsChange([]);
    }

    handleResponse = (response) => {
        if(response && response.status === 'success') {
            reloadCardsGroupsFeatures(this.props, response.new_cards_group_ids)
            showMessage(this.props, '¡' + _('Se han generado los protocolos correctamente') + '!');
        } else {
            showMessage(this.props, _('No se pudieron generar los protocolos') + '.');
        }
    }

    handleProtocolChange = (event, value) => {
        const protocolIds = value.map(protocolInfo => protocolInfo.id);
        this.setState({ protocolIds: protocolIds });
    }

    handleInputChange = (event, value, reason) => {
        if (reason === 'input') {
            this.setState({ inputValue: value });
        }
    }

    filterOptions = (options, state) => {
        const filteredOptions = [];
        const inputValue = state.inputValue.trim().toLowerCase();
        const hasInputText = inputValue.length > 0;
        for (const option of options) {
            if (this.state.protocolIds.includes(option.id)) continue;
            const protocolName = option.name.toLowerCase();
            if (hasInputText && !protocolName.includes(inputValue)) continue;
            filteredOptions.push(option);
        }
        return filteredOptions;
    }

    render(){   
        const render = this.props.selectProtocolSwitch;
        if (!render) return <div></div>;
        let stageProtocolIds = [];
        for (const stageData of Object.values(this.props.projectData.stages)) {
            if (this.props.stageIds.length > 0 && !this.props.stageIds.includes(stageData.id)) continue
            stageProtocolIds = stageProtocolIds.concat(
                Object.keys(stageData.protocols).map((protocolId) => { return parseInt(protocolId) })
            )
        }
        const options = [];
        for (const protocolgroupData of Object.values(this.props.projectData.protocolgroups)) {
            const protocolgroupName = protocolgroupData.attributes.name;
            for (const protocolData of Object.values(protocolgroupData.protocols)) {
                if (!stageProtocolIds.includes(protocolData.id)) continue;
                const protocolName = protocolData.attributes.name;
                const protocolFullName = `${protocolgroupName} - ${protocolName}`;
                options.push({
                    id: protocolData.id,
                    name: protocolFullName
                });
            }
        }
        return (
            <div>
                <div className='sensitive-background' onClick={this.handleClose}></div>
                <div className="add-cards-groups-card-layout card-color">
                    <h4 className='mb-4'>{_("Seleccione los Protocolos que desea agregar")}</h4>
                    <Autocomplete
                        multiple
                        options={options}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.name}
                        onChange={this.handleProtocolChange}
                        inputValue={this.state.inputValue}
                        onInputChange={this.handleInputChange}
                        filterOptions={this.filterOptions}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant='outlined'
                                label={_('Protocolos')}
                                placeholder={_('Busca Aquí') + '...'}
                            />
                        )}
                    />
                    <div className='d-flex justify-content-center'>
                        <Button variant="contained" onClick={this.handleOnClick} className='success-button mt-4'>
                            <SendIcon/>
                            <span style={{ paddingLeft: 10 }}>{ _('Generar')}</span>
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps( state ){
    return {
        stageIds : state.filters.stageIds,
        projectData : state.projectData,
        selectProtocolSwitch  : state.switches.selectProtocol,
        selectedCardsGroups : state.selectedCardsGroups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        popUpMessageChange : popUpMessageChange,
        deleteCards : deleteCards,
        editCards : editCards,
        editFeaturesGroup : editFeaturesGroup,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ProtocolSelectCard)